import { createContext } from 'react';

export const DeveloperProfileContext = createContext({});
export const StoreContext = createContext({});
export const StaticDataContext = createContext({});
